import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { cn } from "@/lib/utils";

type FAQItem = {
  q: string;
  a: string;
};

type FAQAccordionProps = {
  items: FAQItem[];
  dark?: boolean;
};

const FAQAccordion = ({ items, dark }: FAQAccordionProps) => (
  <Accordion
    type="single"
    collapsible
    className={cn("w-full border-t", dark ? "border-[hsl(var(--sd-fg)/0.1)]" : "border-border/55")}
  >
    {items.map((item, index) => (
      <AccordionItem
        key={item.q}
        value={`faq-${index}`}
        className={cn("border-b", dark ? "border-[hsl(var(--sd-fg)/0.09)]" : "border-border/48")}
      >
        <AccordionTrigger
          className={cn(
            "group px-1 py-7 text-left text-[15px] font-medium leading-snug transition-colors duration-400 hover:no-underline",
            dark ? "text-[hsl(var(--sd-fg)/0.86)] hover:text-primary" : "text-foreground hover:text-primary",
          )}
        >
          <span className="grid min-w-0 flex-1 grid-cols-[4.75rem_1fr] items-baseline gap-5">
            <span className={cn("shrink-0 font-mono text-[10px] tracking-[0.16em] transition-colors duration-400", dark ? "text-[hsl(var(--sd-fg)/0.36)] group-hover:text-primary/80" : "text-muted-foreground/78 group-hover:text-primary/75")}>
              FAQ/{String(index + 1).padStart(2, "0")}
            </span>
            <span className="min-w-0">{item.q}</span>
          </span>
        </AccordionTrigger>
        <AccordionContent
          className={cn(
            "pb-7 pl-[5.95rem] pr-1 text-[15px] leading-[1.82] max-sm:pl-1",
            dark ? "text-[hsl(var(--sd-fg)/0.58)]" : "text-muted-foreground",
          )}
        >
          {item.a}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export default FAQAccordion;
